/* eslint-disable import/prefer-default-export */
import { formValueSelector } from 'redux-form';
import getTravelerFormSectionName from './travelerFormName';
import { TRAVEL_DOCUMENT_EXPIRY_DATE } from './constants';
export const getSelected = form => (state, id) => formValueSelector(form)(state, getTravelerFormSectionName(id, TRAVEL_DOCUMENT_EXPIRY_DATE)) || null;
//# sourceMappingURL=travelDocumentExpiryDate.js.map